import { render } from "./PdvView.vue?vue&type=template&id=6fbd6c20&scoped=true"
import script from "./PdvView.vue?vue&type=script&lang=js"
export * from "./PdvView.vue?vue&type=script&lang=js"

import "./PdvView.vue?vue&type=style&index=0&id=6fbd6c20&scoped=true&lang=css"
import "./PdvView.vue?vue&type=style&index=1&id=6fbd6c20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbd6c20"]])

export default __exports__